import type { Dependencies } from "@redux/store";
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { TrainingInvoice, TrainingInvoiceListPaginationParams } from "@shared-kernel/application/ports/admin/admin-repository";
import type { PaginatedResult } from "@shared-kernel/domain/types/paginated-result";

export const retrieveTrainingInvoiceList = createAsyncThunk<
  PaginatedResult<TrainingInvoice>,
  TrainingInvoiceListPaginationParams,
  { extra: Partial<Dependencies> }
>("trainingInvoices/retrieveTrainingInvoiceList", async (params: TrainingInvoiceListPaginationParams, { extra: { adminRepository } }) => {
  return adminRepository!.listTrainingInvoices(params);
});
